import { render, staticRenderFns } from "./ManageApplications.vue?vue&type=template&id=37cb6b0a&"
import script from "./ManageApplications.vue?vue&type=script&lang=js&"
export * from "./ManageApplications.vue?vue&type=script&lang=js&"
import style0 from "./ManageApplications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports